class MCWhatWeDo extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.images = Array.from(this.querySelectorAll('[data-tab-image]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this._onTabClick);
    });
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => {
      tab.removeEventListener('click', this._onTabClick);
    });
  }

  _onTabClick = (event) => {
    const index = Number(event.currentTarget.dataset.tabIndex);
    this.activate(index);
  };

  activate(index) {
    this.tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });

    this.images.forEach((image, i) => {
      image.hidden = i !== index;
    });
  }
}

if (!customElements.get('mc-what-we-do')) {
  customElements.define('mc-what-we-do', MCWhatWeDo);
}
